import { z } from 'zod';
/** Cross-app events travel on the `os.events` queue as `<app>.<entity>.<verb>` (docs/DATABASES.md §37). */
export const OS_EVENTS_QUEUE = 'os.events';
export const EventNameSchema = z.string().regex(/^[a-z][a-z0-9_]*\.[a-z][a-z0-9_]*\.[a-z][a-z0-9_]*$/, 'event name must be <app>.<entity>.<verb>');
export const OsEventSchema = z.object({
    /** Idempotency key for consumers (uuid). */
    id: z.string().uuid(),
    name: EventNameSchema,
    /** Producer app id. */
    source: z.string(),
    tenantId: z.string().uuid().nullable(),
    occurredAt: z.string().datetime(),
    /** Schema version of `data`; bump on breaking change. */
    version: z.number().int().positive().default(1),
    data: z.record(z.unknown()),
});
export function eventName(app, entity, verb) {
    return EventNameSchema.parse(`${app}.${entity}.${verb}`);
}
//# sourceMappingURL=events.js.map